@if (displaySpinner()) {
  <div role="progressbar"
       [attr.aria-live]="ariaLive()"
       aria-label="progress bar"
       [attr.aria-valuenow]="0"
       [attr.aria-valuemin]="0"
       [attr.aria-valuemax]="100"
       [attr.aria-valuetext]="'tdWb.loading.LOADING' | tdWbTranslate">
    <td-wb-spinner class="td-wb-loading-indicator__spinner" />
  </div>
}
